import {
  DELETE_CUSTOMER_PROVIDER,
  DELETE_CUSTOMER_PROVIDER_FAILURE,
  DELETE_CUSTOMER_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteCustomerProviderReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_CUSTOMER_PROVIDER:
      return { ...state, loading: true };
    case DELETE_CUSTOMER_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_CUSTOMER_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteCustomerProviderReducer;
